export enum EScheduleStatus {
  Available = 'available',
  UnAvailable = 'unavailable',
  Pending = 'pending',
  Reserved = 'reserved',
}

export enum EMentoringClassStatus {
  CanceledByMentor = 'canceled_by_mentor',
  CanceledByMentee = 'canceled_by_mentee',
  RequestPending = 'request_pending',
  RequestRejected = 'request_rejected',
  RequestAccepted = 'request_accepted',
  Completed = 'completed',
  TimeLimit = 'time_limit',
}

export enum EFeedbackScore {
  Excellent = 'excellent',
  Good = 'good',
  Average = 'average',
  NeedImprovement = 'need_improvement',
  Bad = 'bad',
  NotApplicable = 'N/A',
}

export enum EExchangeHistoryStatus {
  Accepted = 'accepted', // 정산 완료
  Pending = 'pending', // 정산 신청
  Rejected = 'rejected', // 정산 거절
  Deposit = 'deposit', // 멘토링 수업에 의한 적립
  NeedFeedback = 'need_feedback', // 멘토링 수업 피드백 작성 필요
}

export enum ECreditHistoryStatus {
  Purchase = 'purchase', // 크레딧 구입
  Mentoring = 'mentoring', // 멘토링 수업 신청
  Nonattendance = 'nonattendance', // 멘토의 수업 불참으로인한 수업 크레딧 환불
  Penalty = 'penalty', // 멘토의 수업 정산시 멘토의 패널티를 추가로 멘티에게 주는 크레딧
  Offline = 'offline', // 대면 수업 후 어드민에서 정산
  AddedByAdmin = 'added by admin', //어드민페이지에서 올리는 수강권
}

export enum EMentoringField {
  Consulting = 'consulting',
  Finance = 'finance',
  Tech = 'tech',
}
